export const trainingVideos = [
  {
    id: 'welcome',
    number: 'Welcome',
    title: 'Welcome to IT-AMS New User Training',
    runtime: '02:37',
    description:
      'Get familiar with the training series, what you will learn, how the videos are organized, and how to use the course as both new-user training and an ongoing refresher.',
    video: '/training/media/welcome',
    captions: '/training/captions/welcome-en-US.vtt',
    pdf: '/training/pdfs/module-0-welcome-to-it-ams-user-training.pdf',
  },
  {
    id: '1',
    number: 'Video 1',
    title: 'IT-AMS Overview',
    runtime: '04:06',
    description:
      'Learn what IT-AMS is, what the system supports, who uses it, and how IT-AMS fits into the Head Start monitoring process.',
    video: '/training/media/video-1-it-ams-overview',
    captions: '/training/captions/video-1-it-ams-overview-en-US.vtt',
    pdf: '/training/pdfs/module-1-it-ams-overview.pdf',
  },
  {
    id: '2',
    number: 'Video 2',
    title: 'Account Setup & First-Time Sign In',
    runtime: '04:34',
    description:
      'Learn how an IT-AMS account is created, how to use your assigned credentials, and what to expect when signing in for the first time.',
    video: '/training/media/video-2-account-setup-and-first-time-sign-in',
    captions:
      '/training/captions/video-2-account-setup-and-first-time-sign-in-en-US.vtt',
    pdf: '/training/pdfs/module-2-account-setup-and-first-time-sign-in.pdf',
  },
  {
    id: '3',
    number: 'Video 3',
    title: 'Home Page & System Navigation',
    runtime: '10:17',
    description:
      'Get familiar with the IT-AMS Home page, global navigation, and the common navigation areas you will use to move through the system.',
    video: '/training/media/video-3-home-page-and-system-navigation',
    captions:
      '/training/captions/video-3-home-page-and-system-navigation-en-US.vtt',
    pdf: '/training/pdfs/module-3-home-page-and-system-navigation.pdf',
  },
  {
    id: '4',
    number: 'Video 4',
    title: 'Review Types, Fiscal Year, and Assignments',
    runtime: '03:01',
    description:
      'Learn how review type, fiscal year, and your assigned role affect the reviews, information, and activities available to you in IT-AMS.',
    video: '/training/media/video-4-review-types-fiscal-year-and-assignments',
    captions:
      '/training/captions/video-4-review-types-fiscal-year-and-assignments-en-US.vtt',
    pdf: '/training/pdfs/module-4-review-types-fiscal-year-and-assignments.pdf',
  },
  {
    id: '5',
    number: 'Video 5',
    title: 'Finding & Opening Assigned Reviews',
    runtime: '07:27',
    description:
      'Learn how to find an assigned review, use available filters to narrow the review list, and open the correct review for your work.',
    video: '/training/media/video-5-finding-and-opening-assigned-reviews',
    captions:
      '/training/captions/video-5-finding-and-opening-assigned-reviews-en-US.vtt',
    pdf: '/training/pdfs/module-5-finding-and-opening-assigned-reviews.pdf',
  },
  {
    id: '6',
    number: 'Video 6',
    title: 'Review Details',
    runtime: '06:36',
    description:
      'Learn how to use the Review Details page to confirm review information, understand assignments, and locate the guides and actions available for the review.',
    video: '/training/media/video-6-review-details',
    captions: '/training/captions/video-6-review-details-en-US.vtt',
    pdf: '/training/pdfs/module-6-review-details.pdf',
  },
  {
    id: '7',
    number: 'Video 7',
    title: 'Working Within a Review',
    runtime: '14:35',
    description:
      'Learn how to open and work within a guide, complete applicable Targeted Questions, or TQs, and use Review Tools to access supporting review pages and functions.',
    video: '/training/media/video-7-working-within-a-review',
    captions: '/training/captions/video-7-working-within-a-review-en-US.vtt',
    pdf: '/training/pdfs/module-7-working-within-a-review.pdf',
  },
  {
    id: '8',
    number: 'Video 8',
    title: 'Saving Work & Avoiding Data Loss',
    runtime: '05:07',
    description:
      'Learn when and how IT-AMS saves your work, how to confirm that information has been retained, and practices that help reduce the risk of losing or conflicting with review information.',
    video: '/training/media/video-8-saving-work-and-avoiding-data-loss',
    captions:
      '/training/captions/video-8-saving-work-and-avoiding-data-loss-en-US.vtt',
    pdf: '/training/pdfs/module-8-saving-work-and-avoiding-data-loss.pdf',
  },
  {
    id: '9',
    number: 'Video 9',
    title: 'Profile, Calendar & Availability',
    runtime: '13:33',
    description:
      'Learn how to access your IT-AMS profile, use the calendar, and manage availability information used to support monitoring activities.',
    video: '/training/media/video-9-profile-calendar-and-availability',
    captions:
      '/training/captions/video-9-profile-calendar-and-availability-en-US.vtt',
    pdf: '/training/pdfs/module-9-profile-calendar-and-availability.pdf',
  },
  {
    id: '10',
    number: 'Video 10',
    title: 'Help, Support & Secure Sign-Out',
    runtime: '03:22',
    description:
      'Learn when to contact the IT-AMS Help Desk, what information to include in a support request, and how to securely sign out when your work is complete.',
    video: '/training/media/video-10-help-support-and-secure-sign-out',
    captions:
      '/training/captions/video-10-help-support-and-secure-sign-out-en-US.vtt',
    pdf: '/training/pdfs/module-10-help-support-and-secure-sign-out.pdf',
  },
];

export const completeCoursePdf =
  '/training/pdfs/it-ams-new-user-training-complete-course.pdf';

export const courseSections = [
  { title: 'Welcome', videoIds: ['welcome'] },
  { title: 'Get Started', videoIds: ['1', '2', '3'] },
  { title: 'Work a Review', videoIds: ['4', '5', '6', '7'] },
  { title: 'Stay on Track', videoIds: ['8', '9'] },
  { title: 'Get Help', videoIds: ['10'] },
];

export const getTrainingVideo = id =>
  trainingVideos.find(video => video.id === id);
